import React, {Component} from 'react';
import ReactTooltip from 'react-tooltip';

let helpBubbleCount = 0;

export default class HelpBubble extends Component {
    constructor(props) {
        super(props);
        this.state = {helpBubbleId: `HELP-BUBBLE-ID-${helpBubbleCount++}`};
    }

    getHelpBubble() {
        const {text, place, multiline, inline, tooltipColor} = this.props;
        const tooltipType = tooltipColor || 'dark';

        if (inline) {
            return (
                <span className="help-bubble">
                    <ReactTooltip id={this.state.helpBubbleId} type={tooltipType} />
                    <i
                        data-tip={text}
                        data-for={this.state.helpBubbleId}
                        data-place={place}
                        data-effect="solid"
                        className="fa fa-question-circle"
                        data-multiline={multiline}
                    />
                </span>
            );
        }

        return (
            <div className="help-bubble">
                <ReactTooltip id={this.state.helpBubbleId} />
                <i
                    data-tip={text}
                    data-for={this.state.helpBubbleId}
                    data-place={place}
                    data-effect="solid"
                    className="fa fa-question-circle"
                    data-multiline={multiline}
                />
            </div>
        );
    }

    render() {
        const helpBubble = this.getHelpBubble();

        return helpBubble;
    }
}



// WEBPACK FOOTER //
// ./components/help_bubble.js